import { render } from "./DelayStatList.vue?vue&type=template&id=13fde40a&scoped=true"
import script from "./DelayStatList.vue?vue&type=script&lang=js"
export * from "./DelayStatList.vue?vue&type=script&lang=js"

import "./DelayStatList.vue?vue&type=style&index=0&id=13fde40a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fde40a"],['__file',"src/views/h5/crm/project/view/DelayStatList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13fde40a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13fde40a', __exports__)) {
    api.reload('13fde40a', __exports__)
  }
  
  module.hot.accept("./DelayStatList.vue?vue&type=template&id=13fde40a&scoped=true", () => {
    api.rerender('13fde40a', render)
  })

}


export default __exports__